export default __webpack_public_path__ + "static/font-d1dc6ff3d59c8f106c62c4f833490fa0.woff";